import Controller from '@ember/controller';
import { service } from '@ember/service';

import { task } from 'ember-concurrency';

import styles from 'umg-ember-backend/components/ui/form/fieldset/styles.module.css';
import { getBem } from 'umg-ember-backend/utils/get-bem';

export default class AdminToolItunesIdsUploader extends Controller {
  // Service
  @service fetch;
  @service flashMessages;
  @service headData;
  @service intl;

  // Defaults
  bem = getBem(styles);

  // Actions
  setHeadData = () => {
    this.headData.title = this.intl.t('tool_itunes_ids_uploader.headline');
    this.headData.favicon = 'tool-itunes-ids-uploader';
  };

  // Tasks
  processUpload = task(async (file) => {
    try {
      await this.fetch.post('/tools/itunesIds', {
        data: { filename: file.uploadPath },
      });

      this.flashMessages.success('tool_itunes_ids_uploader.imported');
    } catch (error) {
      const message = error.payload?.errors?.message ?? error;
      this.flashMessages.error(message, {
        rawString: true,
      });
    }
  });
}
